import { render, staticRenderFns } from "./MoreActions.vue?vue&type=template&id=f4b7e682&scoped=true&"
import script from "./MoreActions.vue?vue&type=script&lang=js&"
export * from "./MoreActions.vue?vue&type=script&lang=js&"
import style0 from "./MoreActions.vue?vue&type=style&index=0&id=f4b7e682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b7e682",
  null
  
)

export default component.exports